export default __webpack_public_path__ + "static/media/SearchIcon.8e5b8a97.svg";